<template>
  <AiEducationLayout :menu-items="menuItems">
    <EducationPageHeader title="我的作业" description="查看当前学生授权范围内的作业和提交状态" />
    <ContentWrap>
      <EducationState v-if="state === 'loading'" state="loading" title="正在加载作业" />
      <EducationState
        v-else-if="state === 'error'"
        state="error"
        title="作业加载失败"
        description="请检查网络后重试。"
        @retry="load"
      />
      <EducationState
        v-else-if="!assignments.length"
        state="empty"
        title="暂无作业"
        description="教师发布作业后会显示在这里。"
      />
      <el-table v-else :data="assignments" row-key="id" stripe>
        <el-table-column prop="title" label="作业" min-width="220" />
        <el-table-column prop="dueTime" label="截止时间" width="180">
          <template #default="{ row }">{{ formatDate(row.dueTime) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="130">
          <template #default="{ row }">
            <el-tag :type="statusType(row)">{{ statusText(row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分" width="100">
          <template #default="{ row }">{{ row.score ?? '—' }}</template>
        </el-table-column>
      </el-table>
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import type { EducationMenuItem } from '../layout/types'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'
import { getMyStudentAssignments, type StudentAssignmentVO } from '@/api/aiEducation'

defineOptions({ name: 'AiEducationStudentAssignments' })
const assignments = ref<StudentAssignmentVO[]>([])
const state = ref<'loading' | 'ready' | 'error'>('loading')
const menuItems: EducationMenuItem[] = [
  {
    title: '学习首页',
    path: '/ai-Application-center/ai-education/student/home',
    icon: 'ep:home-filled'
  },
  {
    title: '我的课程',
    path: '/ai-Application-center/ai-education/student/courses',
    icon: 'ep:reading'
  },
  {
    title: '我的作业',
    path: '/ai-Application-center/ai-education/student/assignments',
    icon: 'ep:document-checked'
  },
  {
    title: 'AI 学伴',
    path: '/ai-Application-center/ai-education/student/assistant',
    icon: 'ep:magic-stick'
  }
]
const load = async () => {
  state.value = 'loading'
  try {
    assignments.value = (await getMyStudentAssignments()) || []
    state.value = 'ready'
  } catch {
    state.value = 'error'
  }
}
const formatDate = (value?: string) => (value ? new Date(value).toLocaleString() : '未设置')
const statusText = (row: StudentAssignmentVO) =>
  row.expired
    ? '已逾期'
    : row.submissionStatus == null
      ? '待完成'
      : row.submissionStatus >= 30
        ? '已批改'
        : row.submissionStatus >= 10
          ? '已提交'
          : '草稿'
const statusType = (row: StudentAssignmentVO) => {
  const status = row.submissionStatus ?? 0
  return row.expired ? 'danger' : status >= 30 ? 'success' : status >= 10 ? 'info' : 'warning'
}
onMounted(load)
</script>
